<script>
import Layout from '@layouts/public.vue'
import { mapGetters, mapActions } from 'vuex'
import baseMixin from '@/mixins/baseMixin'
import { ErrorPageFactory } from '@/services/error/ErrorPageFactory'

export default {
  name: 'Error',
  components: { Layout },
  mixins: [baseMixin],
  data() {
    return {
      factory: null,
      title: '',
      meta: '',
    }
  },
  computed: {
    ...mapGetters({
      isUserLoggedIn: 'auth/isUserLoggedIn',
      currentUser: 'auth/currentUser',
    }),
  },
  created() {
    this.factory = ErrorPageFactory(this.$route.meta.type)
    this.title = this.factory.errorText
    this.meta = this.factory.errorCode
  },

  methods: {
    ...mapActions({
      logout: 'auth/logOut',
    }),
    signOut() {
      this.logout()
    },
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [{ name: 'description', content: this.meta }],
    }
  },
}
</script>

<template>
  <Layout>
    <div class="text-center  white--text">
      <div>
        <h3 class="error-title font-weight-bold display-4 my-10">
          {{ factory.title }}
        </h3>

        <p class="error-desc display-1 font-weight-bold mt-0">
          {{ factory.desc }}
        </p>
        <p
          class="error-sub-desc subtitle-1 font-weight-medium"
          v-text="
            `${factory.showErrorCode ? '(' + factory.errorCode + ') ' : ''} ${
              factory.subDesc
            }`
          "
        ></p>

        <div class="error-code" :data-error-code="factory.errorText"></div>

        <div
          :class="[
            'd-flex justify-center mt-10',
            $mq === 'sm' || $mq === 'xs' ? 'flex-column ' : '',
          ]"
        >
          <BaseButton
            v-show="isUserLoggedIn || currentUser"
            id="error-page-logout-btn"
            large
            text
            outlined
            color="white"
            :class="[
              'rounded-lg text-capitalize no-letter-spacing',
              isMobileViewPort ? 'mb-2' : 'mr-2',
            ]"
            @click="signOut"
          >
            <v-icon left class="white--text">mdi-arrow-left</v-icon>
            Logout
          </BaseButton>
          <BaseButton
            if="error-page-go-home-btn"
            large
            light
            color="white"
            :class="[
              'rounded-lg text-capitalize no-letter-spacing',
              isMobileViewPort ? '' : 'ml-2',
            ]"
            :href="factory.goBackURL"
            v-text="factory.goBackText"
          >
          </BaseButton>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
.logo {
  position: absolute;
  top: 0;
  display: inline-block;
  margin: 25px 15px;
}
</style>
